import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    redirect: 'home'
  },
  {
    path: "/home",
    name: 'home',
    component: Home
  },
  {
    path: '/order',
    name: 'order',
    component: () => import('../views/Order.vue') 
  },
  {
    path: '/orderDetail',
    name: 'orderDetail',
    component: () => import('../views/OrderDetail.vue')
  },
  {
    path: '/PIN',
    name: 'pin',
    component: () => import('../views/PIN.vue')
  },
  {
    path: '/create',
    name: 'create',
    component: () => import('../views/CreateManager&Assistant.vue')
  },
  {
    path: '/store',
    name: 'store',
    component: () => import('../views/Store.vue')
  },
  {
    path: '/management',
    name: 'management',
    component: () => import('../views/Management.vue')
  },
  {
    path: '/noaccess',
    name: 'noaccess',
    component: () => import('../views/NoAccess.vue')
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, form, next) => {
  const toName = to.name
  if (toName !== 'home') {
    if (toName == 'noaccess') return next()
    if (toName == 'order') {
      // const name = to.query.name
      const name = JSON.parse(localStorage.getItem("result")) ? JSON.parse(localStorage.getItem("result")).sub : false
      if (!name) localStorage.removeItem("username")
      if (name) localStorage.setItem("username", name)
    }
    const username = localStorage.getItem("username")
    if (username) {
      next()
    } else {
      next('/noaccess')
    }
  } else {
    localStorage.removeItem("username")
    next()
  }
})

export default router
